import { Rocket, Settings, Shield, Users } from "lucide-react";

function Choose() {
  const whyChooseUs = [
    {
      icon: Settings,
      title: "Deep Expertise",
      description: "Real-time streaming and cloud technologies",
    },
    {
      icon: Users,
      title: "Customized Solutions",
      description: "Solutions aligned with your business goals",
    },
    {
      icon: Rocket,
      title: "Cutting-Edge AI",
      description: "Advanced AI and data integration capabilities",
    },
    {
      icon: Shield,
      title: "Proven Success",
      description: "Trusted by enterprises worldwide",
    },
  ];

  return (
    <>
      {/* WHY CHOOSE US */}
      <section className="bg-white py-16 sm:py-20">
        <div className="mx-auto max-w-7xl px-4">
          <h2 className="mb-4 text-center text-3xl font-bold text-gray-800 sm:text-4xl">
            Why Choose Xstream Minds
          </h2>
          <p className="mx-auto mb-12 max-w-3xl text-center text-gray-500">
            Trusted by enterprises worldwide to deliver scalable and innovative solutions.
          </p>

          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {whyChooseUs.map((item) => (
              <div key={item.title} className="text-center">
                <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-orange-500">
                  <item.icon size={28} className="text-white" />
                </div>
                <h3 className="mb-2 text-lg font-semibold text-gray-800">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-500">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-gray-900 py-16 sm:py-20">
        <div className="mx-auto max-w-3xl px-4 text-center">
          <h2 className="mb-4 text-3xl font-bold text-white sm:text-4xl">
            Ready to Transform Your Business?
          </h2>
          <p className="mb-8 text-gray-300">
            Let’s discuss how our real-time data solutions can accelerate your digital transformation.
          </p>

          <a
            href="/contact"
            className="inline-block rounded-md bg-orange-500 px-8 py-3 text-lg font-semibold text-white transition hover:bg-orange-600"
          >
            Start Your Journey
          </a>
        </div>
      </section>
    </>
  );
}
export default Choose;